export default __webpack_public_path__ + "src/assets/Flowy_User__IMPORT_MODEL.xlsx";